export const STATUSES = [
  { value: "lead", label: "Lead" },
  { value: "active", label: "Active" },
  { value: "inactive", label: "Inactive" },
];

export function statusStyle(status) {
  switch (status) {
    case "active": return "bg-green-50 text-green-700 border-green-200";
    case "lead": return "bg-blue-50 text-[#002FA7] border-blue-200";
    case "inactive": return "bg-gray-100 text-gray-500 border-gray-200";
    default: return "bg-gray-100 text-gray-500 border-gray-200";
  }
}

export function formatDateTime(iso) {
  return new Date(iso).toLocaleString(undefined, { dateStyle: "medium", timeStyle: "short" });
}

const BYTES_PER_KB = 1024;
const BYTES_PER_MB = BYTES_PER_KB * BYTES_PER_KB;

export function formatFileSize(bytes) {
  if (bytes == null) return "";
  if (bytes < BYTES_PER_KB) return `${bytes} B`;
  if (bytes < BYTES_PER_MB) return `${(bytes / BYTES_PER_KB).toFixed(0)} KB`;
  return `${(bytes / BYTES_PER_MB).toFixed(1)} MB`;
}

// Live input mask: progressively format digits as XXX-XXX-XXXX while typing.
export function formatPhoneInput(value) {
  const d = String(value || "").replace(/\D/g, "").slice(0, 10);
  if (d.length <= 3) return d;
  if (d.length <= 6) return `${d.slice(0, 3)}-${d.slice(3)}`;
  return `${d.slice(0, 3)}-${d.slice(3, 6)}-${d.slice(6)}`;
}

// Display: render a stored phone as XXX-XXX-XXXX when it has 10 digits
// (drops a leading US "1"); otherwise returns the value as-is.
export function formatPhone(value) {
  if (!value) return "";
  let d = String(value).replace(/\D/g, "");
  if (d.length === 11 && d.startsWith("1")) d = d.slice(1);
  if (d.length === 10) return `${d.slice(0, 3)}-${d.slice(3, 6)}-${d.slice(6)}`;
  return value;
}

